"use client";

import { useState, useEffect } from "react";
import { useRouter } from "@/i18n/navigation";
import { useSession } from "@/hooks/use-session";
import { LandingNav } from "@/components/landing/landing-nav";
import { LandingHero } from "@/components/landing/landing-hero";
import { LandingHowItWorks } from "@/components/landing/landing-how-it-works";
import { LandingProductSummary } from "@/components/landing/landing-product-summary";
import { LandingShowcaseCarousel } from "@/components/landing/landing-showcase-carousel";
import { LandingFaq } from "@/components/landing/landing-faq";
import { LandingCta } from "@/components/landing/landing-cta";
import { LandingFooter } from "@/components/landing/landing-footer";
import { OnboardingModal } from "@/components/onboarding/onboarding-modal";
import { BrowserBanner } from "@/components/landing/browser-banner";

const ONBOARDING_SEEN_KEY = "onboarding_seen";

export function LandingPage() {
  const { isAuthenticated } = useSession();
  const router = useRouter();

  const [showOnboarding, setShowOnboarding] = useState(false);
  const [showBrowserBanner, setShowBrowserBanner] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(ONBOARDING_SEEN_KEY)) {
      setShowOnboarding(true);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      router.replace("/new");
    }
  }, [isAuthenticated, router]);

  const handleBannerDismiss = () => {
    setShowBrowserBanner(false);
  };

  const handleOnboardingComplete = () => {
    localStorage.setItem(ONBOARDING_SEEN_KEY, "1");
    router.push("/sign-up");
  };

  if (isAuthenticated) {
    return null;
  }

  if (showOnboarding) {
    // Show browser banner first, then onboarding after dismiss
    if (showBrowserBanner) {
      return <BrowserBanner onDismiss={handleBannerDismiss} />;
    }
    return (
      <OnboardingModal
        isOpen
        onComplete={handleOnboardingComplete}
        source="pre_auth"
      />
    );
  }

  return (
    <div className="min-h-screen bg-landing-bg text-ink">
      <LandingNav />
      <LandingHero />
      <LandingHowItWorks />
      <LandingProductSummary />
      <LandingShowcaseCarousel />
      <LandingFaq />
      <LandingCta />
      <LandingFooter />
    </div>
  );
}
